export enum PreferenceStatus {
  COMPLETED = 'COMPLETED',
  NOT_REQUESTED = 'NOT_REQUESTED',
  REQUESTED = 'REQUESTED'
}

export type SellerCollectionPreference = {
  createdAt: string;
  datePreferences: string[];
  enquiryId: number;
  expiresAt: string;
  isExpired: boolean;
  isSubmitted: boolean;
}
